export * from './DelegoMethods'
